import { render, staticRenderFns } from "./DataQuery.vue?vue&type=template&id=2a5c00dd&scoped=true"
import script from "./DataQuery.vue?vue&type=script&lang=js"
export * from "./DataQuery.vue?vue&type=script&lang=js"
import style0 from "./DataQuery.vue?vue&type=style&index=0&id=2a5c00dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c00dd",
  null
  
)

export default component.exports